import { useEffect, useState } from 'react';
import { UserService } from '../../Services/User.service';
import HealthQuestionnaire from '../ProfileManagement/HealthQuestionnaire'
import TokenService from '../../Services/Token.service';
import Loader from '../../Components/Loader';
import { Accordion, Modal } from 'react-bootstrap';
import Toaster from '../../Components/Toaster';
function HealthQuestionnairePopup({showHealthQuestionnaire, handleCloseHealthQuestionModal, job}){
const [userData, setUserData]= useState(null);
const [loading, setLoading] = useState(true);
 
const [showToast, setShowToast] = useState(false);
const [toastMessage, setToastMessage] = useState('');
const [toastVariant, setToastVariant] = useState('');

async function getUserDetails(){

    try{
        const result = await UserService.viewProfile(TokenService.getUserId());
        setUserData(result.profile);
    }
    catch(e){
        console.log(e);
    }
    finally {
      setLoading(false);
    }
}    

useEffect(()=>{
    getUserDetails();
},[]);

return (
    <>
    <div>  
        <Loader loading={loading} />

        
        {userData !==null  && (
            <>
             <Modal  dialogClassName="large-modal" show={showHealthQuestionnaire} centered onHide={handleCloseHealthQuestionModal} dialogclassname="el-deactivate-modal" backdrop="static">
                <Modal.Body>
                          <div className="profile-setting-accord">
                                <div className="el-card-content el-custom-accordion">
                                        {/*  className="d-sm-flex align-items-md-center" */}
                                        <div className="el-property-details-card-content">
                                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                                <Accordion alwaysOpen defaultActiveKey={["3"]} >
                                                    <HealthQuestionnaire
                                                        userData={userData} selectedGender={userData.gender} type={"donor"} onHide={handleCloseHealthQuestionModal}
                                                        setToastMessage={setToastMessage} setToastVariant={setToastVariant} setShowToast={setShowToast}
                                                        setLoading={setLoading}
                                                        job={job}
                                                    >
                                                    </HealthQuestionnaire>
                                                </Accordion>
                                            </div>
                                        </div>
                                </div>
                            </div>
                </Modal.Body>
            </Modal>
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
            </>
        )}

    </div>
    </>
);
}

export default HealthQuestionnairePopup; 